<h1 matDialogTitle>{{ 'CONFIRM' | translate }}</h1>
<div mat-dialog-content>{{ data.confirmMessage }}</div>
<div mat-dialog-actions>
  <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(true)">
    {{ 'CONFIRM.LOWER.CASE' | translate }}
  </button>
  <button mat-button (click)="dialogRef.close(false)">
    {{ 'CANCEL.LOWER.CASE' | translate }}
  </button>
</div>
